// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26Y0o","title":"Header_title__qiu3k","left":"Header_left__3M5sq","clinicName":"Header_clinicName__3S6KF"};